import React from 'react';

export function OnlineTab() {
    return (
        <div>
            <h1>Online Tab</h1>
        </div>
    );
}